import React from 'react';
import LoadingProgress from './LoadingProgress';

// Shows the loading progress, the fetch error or the warnings after loading. Renders children when the invoices are ready.
const LoadStatus = ({ loading, progress, fetchError, missingInvoices, refreshError, children }) => (
    <>
        {loading && !fetchError && <LoadingProgress progress={progress} />}
        {fetchError && <div style={{ padding: '1rem', color: 'red' }}>Fel vid hämtning: {fetchError}</div>}

        {!loading && !fetchError && (
            <>
                {missingInvoices.length > 0 && (
                    <div style={{ padding: '1rem', color: 'red' }}>
                        Varning: fakturadetaljer kunde inte hämtas för {missingInvoices.length} av {progress.total} fakturor. Summorna kan vara ofullständiga.
                        <ul style={{ margin: '0.5rem 0 0' }}>
                            {missingInvoices.map((m) => <li key={m.documentNumber}>Faktura {m.documentNumber}: {m.error}</li>)}
                        </ul>
                    </div>
                )}

                {refreshError && <div style={{ padding: '1rem', color: 'red' }}>{refreshError}</div>}

                {children}
            </>
        )}
    </>
);

export default LoadStatus;
